import { useState } from "react";
import { Modal, Spinner } from "reactstrap";
import { HiOutlineTrash } from "react-icons/hi2";

// Confirmación para acciones que no se pueden deshacer (p. ej. eliminar). Reemplaza
// al aviso con botones que se cerraba solo a los pocos segundos. `onConfirm` puede
// ser async: el botón queda en "Procesando…" hasta que termina, y si la acción
// falla el diálogo sigue abierto para reintentar o cancelar.
const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "Eliminar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
}) => {
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onConfirm?.();
    } finally {
      setBusy(false);
    }
  };

  const handleCancel = () => {
    if (!busy) onCancel?.();
  };

  return (
    <Modal isOpen={open} toggle={handleCancel} centered className="gm-confirm-dialog" autoFocus={false}>
      <div className="gm-confirm-body">
        <span className="gm-confirm-icon" aria-hidden="true"><HiOutlineTrash size={22} /></span>
        <div>
          <h3 className="gm-confirm-title">{title}</h3>
          {description && <p className="gm-confirm-text">{description}</p>}
        </div>
      </div>
      <div className="gm-confirm-actions">
        <button type="button" className="gm-secondary-button" onClick={handleCancel} disabled={busy} autoFocus>
          {cancelLabel}
        </button>
        <button type="button" className="gm-danger-button" onClick={handleConfirm} disabled={busy}>
          {busy ? <><Spinner size="sm" /> Procesando…</> : confirmLabel}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
